import SiloIcon from './SiloIcon';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

export enum OptionType {
  moveToDelivery = 'moveToDelivery',
  moveToSilo = 'moveToSilo',
  moveToPickup = 'moveToPickup',
  delete = 'delete',
  edit = 'edit',
}

export type CartDeliveryAddress = {
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string;
  addressLocality: string;
  addressPostcode: string;
  addressDistrict: string;
  country: string;
  company: string;
};

export type UserSilo = {
  id: number;
  addressID?: string | null;
  name: string;
  icon?: string | null;
  description: string;
  capacity: number;
  currentProduce: string;
  freeCapacity: number;
  retailerID?: string | null;
  address: CartDeliveryAddress | undefined;
};

interface Props {
  silos: UserSilo[];
  onOptionSelect: (option: OptionType) => void;
  isSilo: boolean;
  t: (key: string) => string;
}

const CartItemButtons: React.FC<Props> = ({
  silos,
  onOptionSelect,
  isSilo,
  t,
}) => {
  return (
    <div
      className={`flex ${
        isSilo ? 'justify-end gap-1-0' : 'justify-between gap-1-0'
      }`}
    >
      {!isSilo && silos?.length > 0 && (
        <button
          className="flex items-center gap-0-5 rounded-base  bg-primary-yellow px-1-0 py-0-5 hover:bg-opacity-70"
          onClick={() => onOptionSelect(OptionType.moveToSilo)}
        >
          <div className="flex items-center">
            <AddIcon className="w-2-4 h-2-4 text-green-700" />
            <SiloIcon className="w-2-0 h-auto" />
          </div>
          <span className="text-body2 font-semibold text-green-700">
            {t('checkout.to_silo')}
          </span>
        </button>
      )}

      <button
        className="flex items-center gap-0-5 rounded-base  bg-primary-yellow px-1-0 py-0-5 hover:bg-opacity-70"
        onClick={() => onOptionSelect(OptionType.delete)}
      >
        <DeleteOutlineOutlinedIcon className="w-2-4 h-2-4 text-green-700" />
        <span className="text-body2 font-semibold text-green-700">
          {t('checkout.delete')}
        </span>
      </button>

      <button
        className="flex items-center gap-0-5 rounded-base  bg-primary-yellow px-1-0 py-0-5 hover:bg-opacity-70"
        onClick={() => onOptionSelect(OptionType.edit)}
      >
        <LocalShippingOutlinedIcon className="w-2-4 h-2-4 text-green-700" />
        <span className="text-body2 font-semibold text-green-700">
          {t('checkout.delivery_type')}
        </span>
      </button>
    </div>
  );
};

export default CartItemButtons;
